export const m0l2Solution = `// Cairo is a typed language. A popular type is \`felt252\`, which is like a number.
// The function below is missing some types and there are a couple errors. Can you fix this?
// do not modify code on this line or above

//  TODO: Edit this function
fn add(a: felt252, b: felt252) -> felt252 {
    let c = a + b;
    return c;
}


// do not modify code on this line or below

fn main() -> felt252 {
    add(3, 5) 
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
